/**
 * innvolo-carrusel.js — carrusel de fundido del hero.
 *
 * Se inicializa solo y se re-inicializa cuando el editor de temas
 * reinyecta la sección. Si hay una sola diapositiva no monta mandos.
 */
(function () {
  'use strict';

  var CLASE_MANDO = 'innvolo-hero__mando';

  function iniciar(carrusel) {
    if (carrusel.dataset.innvoloIniciado === 'si') return;
    carrusel.dataset.innvoloIniciado = 'si';

    var diapos = carrusel.querySelectorAll('[data-innvolo-diapo]');
    var mandos = carrusel.querySelector('[data-innvolo-mandos]');
    if (!diapos.length || !mandos) return;

    var actual = 0;
    var reloj = null;
    var sinMovimiento =
      (window.innvolo && window.innvolo.sinMovimiento) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoPedido = carrusel.dataset.innvoloAuto !== 'false';
    var intervalo = parseInt(carrusel.dataset.innvoloIntervalo, 10) || 7000;

    function ir(n) {
      actual = n;
      diapos.forEach(function (d, i) {
        d.dataset.innvoloActiva = i === n ? 'si' : 'no';
        d.setAttribute('aria-hidden', i === n ? 'false' : 'true');
      });
      Array.prototype.forEach.call(mandos.children, function (b, i) {
        b.setAttribute('aria-pressed', String(i === n));
      });
    }

    function parar() {
      if (reloj) clearInterval(reloj);
      reloj = null;
    }

    function arrancar() {
      parar();
      if (!autoPedido || sinMovimiento || diapos.length < 2) return;
      reloj = setInterval(function () {
        ir((actual + 1) % diapos.length);
      }, intervalo);
    }

    if (diapos.length > 1) {
      diapos.forEach(function (_, i) {
        var boton = document.createElement('button');
        boton.type = 'button';
        boton.className = CLASE_MANDO;
        boton.setAttribute('aria-label', 'Ver imagen ' + (i + 1) + ' de ' + diapos.length);
        boton.addEventListener('click', function () {
          ir(i);
          arrancar();
        });
        mandos.appendChild(boton);
      });
    }

    carrusel.addEventListener('mouseenter', parar);
    carrusel.addEventListener('mouseleave', arrancar);
    carrusel.addEventListener('focusin', parar);
    carrusel.addEventListener('focusout', arrancar);

    /* No seguir gastando trabajo cuando la pestaña está oculta. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar();
      else arrancar();
    });

    ir(0);
    arrancar();
  }

  function iniciarTodos(raiz) {
    (raiz || document).querySelectorAll('[data-innvolo-carrusel]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos(document);
    });
  } else {
    iniciarTodos(document);
  }

  /* El editor de temas reemplaza el nodo entero al editar la sección. */
  document.addEventListener('shopify:section:load', function (e) {
    iniciarTodos(e.target);
  });
})();
